// extracted by mini-css-extract-plugin
export var paginationContainer = "_6x-0";